import { useState, useEffect } from 'react';

export function useTouchDevice(): boolean {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(false);

  useEffect(() => {
    // Primary touch detection via Media Queries (most reliable method)
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const hasFinePointer = window.matchMedia('(pointer: fine)').matches;

    // If coarse pointer is present, it's likely a touch device
    // If only fine pointer is present, it's likely desktop
    if (hasCoarsePointer) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsTouchDevice(true);
      return;
    }

    if (hasFinePointer && !hasCoarsePointer) {
      setIsTouchDevice(false);
      return;
    }

    // Fallback for older browsers - but more cautious
    const hasTouchStart = 'ontouchstart' in window;
    const hasRealTouchPoints = navigator.maxTouchPoints > 1; // Only > 1, not 1

    setIsTouchDevice(hasTouchStart || hasRealTouchPoints);
  }, []);

  return isTouchDevice;
}
